import { getAuth, signOut } from "firebase/auth";

export const logoutUser = () => async (dispatch) => {
    const auth = getAuth();

    try {
        await signOut(auth);
        // Dispatch Redux actions
        dispatch({ type: 'LOGOUT' });
        if(!window.location.pathname.toLowerCase().includes('/measure')){
            console.log("User is signed out");
            if (window.location.pathname.toLowerCase().includes('taplr.app')) {
                // window.location.replace('/taplr.app/login');
            } else {
                window.location.replace('/login');
            }
        }
   
    } catch (error) {
        console.error('Error during sign out:', error);
    }
};